<template>
    <div class="row">
        <div class="col">
            <div class="table-responsive pb-4" v-if="votingPage">
                <table class="table table-bordered table-hover mt-3">
                    <thead class="thead-light">
                    <tr>
                        <th scope="col">Branch</th>
                        <th scope="col">Type</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Status</th>
                        <th scope="col">Votes</th>
                        <th scope="col">Initiator</th>
                        <th scope="col">You</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="element.id" v-for="element in votingPage.elements" @click="clickRowHandler(element.id)">
                        <td>{{element.getBranchNameAsString()}}</td>
                        <td>{{element.getTypeAsString()}}</td>
                        <td>{{element.name}}</td>
                        <td>{{element.getStatusAsString()}}</td>
                        <td :title="element.getVotesAsString()">
                            <span v-if="element.votes.agree !== undefined">
                                <span class="text-success">{{element.votes.agree}}</span> /
                            </span>

                            <span v-if="element.votes.disagree !== undefined">
                                <span class="text-danger">{{element.votes.disagree}}</span> /
                            </span>

                            <span v-if="element.votes.abstain !== undefined">
                                <span class="text-warning">{{element.votes.abstain}}</span> /
                            </span>

                            <span v-if="element.votes.ignored !== undefined">
                                <span class="text-secondary">{{element.votes.ignored}}</span>
                            </span>
                        </td>
                        <td>{{element.getInitiatorAsString()}}</td>
                        <td>{{element.getCurrentVoteAsString()}}</td>
                    </tr>
                    </tbody>
                </table>

                <div class="tbl-paging">
                    <span>Page</span>
                    <button class="btn tbl-paging__btn" @click="prevPage" :disabled="isPrevPageAvailable === false">
                        <span>&laquo;</span>
                    </button>

                    <input class="form-control tbl-paging__page-number" type="number" min="1"
                           :max="votingPage.totalPages"
                           step="1" v-model.number="page" @input="setPage">

                    <button class="btn tbl-paging__btn" @click="nextPage" :disabled="isNextPageAvailable === false">
                        <span>&raquo;</span>
                    </button>

                    <span class="tbl-paging__total">from <strong>{{ votingPage.totalPages }}</strong></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";
    import {HttpHandler} from "@/http/HttpHandler";
    import {Voting} from "@/entities/voting/Voting";
    import {Page} from "@/entities/Page";
    import store from "@/store/index";

    @Component
    export default class VotingTable extends Vue {
        private page: number = 1;
        private votingPage: Page<Voting> | null = null;

        get isPrevPageAvailable(): boolean {
            return this.page > 1;
        }

        get isNextPageAvailable(): boolean {
            if (this.votingPage) {
                return this.votingPage.totalPages > this.page;
            }

            return false;
        }

        async prevPage(): Promise<void> {
            if (!this.isPrevPageAvailable) return;
            this.page = +this.page - 1;

            await this.getVotingTable(this.page);
        }

        async nextPage(): Promise<void> {
            if (!this.isNextPageAvailable) return;
            this.page = +this.page + 1;

            await this.getVotingTable(this.page);
        }

        async setPage(): Promise<void> {
            await this.getVotingTable(this.page);
        }

        clickRowHandler(id: number) {
            this.$router.push({ name: 'Voting Detail', params: { id: id.toString() } });
        }

        async getVotingTable(page: number): Promise<void> {
            const httpHandler = new HttpHandler(store);
            this.votingPage = await httpHandler.getVotingTable(page);
        }

        async created() {
            await this.getVotingTable(this.page);
        }
    }
</script>

<style scoped lang="scss">
    th, td {
        width: 1%;
        white-space: nowrap;
    }

    tbody tr {
        cursor: pointer;
    }

    .tbl-paging {
        display: flex;
        align-items: center;

        &__btn {
            border-radius: .25rem;
            border: 1px solid #dee2e6;
            margin: 0 .25rem;

            &:hover {
                text-decoration: none;
                background-color: #e9ecef;
                border-color: #dee2e6;
            }
        }

        &__page-number {
            appearance: textfield;
            width: 4rem;
            text-align: center;
        }
    }
</style>
